import { Component, OnInit } from '@angular/core';
import {
  AuthenticationCallbacks,
  UserManager
} from '@gls-group/gls-user-manager';
import { AuthenticationService } from '../authentication.service';
import { ErrorHandlerService } from '../error-handler.service';
import { EventOptionsBuilder, GoogleAnalyticsService } from '../google-analytics-service';

@Component({
  selector: 'app-attempt-login',
  template: ` <ngx-gls-spinner></ngx-gls-spinner> `,
})
export class AttemptLoginComponent implements OnInit {
  private userManager: UserManager;

  constructor(
    private window: Window,
    private auth: AuthenticationService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private error: ErrorHandlerService
  ) {
    this.userManager = auth.userManager;
  }

  async ngOnInit() {
    this.googleAnalyticsService.sendPageView('Authentication: Login', '/authenticate');

    const gaEventBuilder = new EventOptionsBuilder();
    gaEventBuilder.setCategory("SSO Authentication Login");
    gaEventBuilder.setPage("/authenticate");
    gaEventBuilder.setNonInteraction(true);
    await this.userManager._oidcManager.clearStaleState();

    const queryParams = new URLSearchParams(this.window.location.search);
    if (queryParams.has('error')) {
      const error = queryParams.get('error'); //error=login_required
      gaEventBuilder.setAction("ERROR").setLabel(`ERROR_MESSAGE: ${JSON.stringify(error)}`);
      this.googleAnalyticsService.sendEvent(gaEventBuilder.getResult());
      this.error.navigateToErrorPage();
      return;
    }
    if(queryParams.has('state')) {
      new AuthenticationCallbacks(this.userManager).signInRedirectCallback().then(user => {
        if (!user) {
          console.error("No user found");
          gaEventBuilder.setAction("ERROR").setLabel("No user found after redirect callback")
          this.googleAnalyticsService.sendEvent(gaEventBuilder.getResult());
          this.error.navigateToErrorPage();
          return;
        }

        const productEntrypointURL = this.auth.createProductRedirectUrl(user);
        gaEventBuilder.setAction("SUCCESSFUL LOGIN").setLabel(`Successful login and redirecting to ${removeSensitiveData(productEntrypointURL)}`).setBeacon();
        this.googleAnalyticsService.sendEvent(gaEventBuilder.getResult());
        window.location.replace(productEntrypointURL.toString());
      }, (err) => {
        console.error(err);
        this.googleAnalyticsService.sendEvent(gaEventBuilder.getResult());
        if (err instanceof Error) {
          err = err.message;
          gaEventBuilder.setAction("API ERROR").setLabel(`REDIRECT_CALLBACK:ERROR_MESSAGE: ${JSON.stringify(err)}`);
        } else {
          gaEventBuilder.setAction("API ERROR").setLabel(`REDIRECT_CALLBACK:ERROR_MESSAGE: ${JSON.stringify(err)}`);
        }
        if(err.includes('iat is in the future')){
          err = 'Please synchronize or system clock.'
        }
        this.error.navigateToErrorPage(err);
      });
    } else {
      this.userManager.signIn().then(() => {
        console.log('userManager.signIn()');
        gaEventBuilder.setAction("SUCCESSFUL REDIRECT").setLabel("Succesful redirect sign in to keycloak").setBeacon();
        this.googleAnalyticsService.sendEvent(gaEventBuilder.getResult());
      }, (error) => {
        gaEventBuilder.setAction("API ERROR").setLabel(`REDIRECT_KEYCLOAK:ERROR_MESSAGE:${JSON.stringify(error)}`)
        this.googleAnalyticsService.sendEvent(gaEventBuilder.getResult());
        console.log('Was not able to sign in redirect', error);
        this.error.navigateToErrorPage();
      });
    }
  }
}


function removeSensitiveData(url: URL) {
  let newUrl = new URL(url.toString());
  newUrl.searchParams.delete("token");
  return newUrl;
}
